import { z } from 'zod';

// CNPJ aceita 14 dígitos com ou sem máscara (`12.345.678/0001-90` ou `12345678000190`).
// Validação de dígitos verificadores fica para uma helper se a outra IA exigir;
// por ora, garantimos só o formato.
const CNPJ_DIGITS_RE = /^\d{14}$|^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;

export const companyInputSchema = z
  .object({
    nome: z.string().trim().min(1, 'Obrigatório').max(150, 'Máximo 150 caracteres'),
    documento: z
      .string()
      .trim()
      .min(1, 'Obrigatório')
      .regex(CNPJ_DIGITS_RE, 'CNPJ inválido. Use 14 dígitos.'),
    telefone: z.string().trim().min(1, 'Obrigatório').max(20, 'Máximo 20 caracteres'),
    permiteApontamentoFuturo: z.boolean(),
    permiteApontamentoAtrasado: z.boolean(),
    diasUteisApontamentoAtrasado: z
      .number()
      .int('Apenas inteiros')
      .min(0, 'Mínimo 0')
      .max(999, 'Máximo 999')
      .nullable()
      .optional(),
    enderecoComercialId: z.number().int().positive().nullable().optional(),
    enderecoFaturamentoId: z.number().int().positive().nullable().optional(),
    enderecoCorrespondenciaId: z.number().int().positive().nullable().optional(),
    integracaoIntegraNotaAtiva: z.boolean(),
    integracaoIntegraNotaTokenHomologacao: z
      .string()
      .trim()
      .max(200, 'Máximo 200 caracteres')
      .nullable()
      .optional(),
    integracaoIntegraNotaTokenProducao: z
      .string()
      .trim()
      .max(200, 'Máximo 200 caracteres')
      .nullable()
      .optional(),
    simplesNacional: z.boolean(),
    ativo: z.boolean().optional(),
  })
  .refine(
    // Quando `permiteApontamentoAtrasado=true`, `diasUteisApontamentoAtrasado` é obrigatório > 0.
    // (Server-side: validação aplicada na ApiCompanyCreate/Update.)
    (data) =>
      !data.permiteApontamentoAtrasado ||
      (data.diasUteisApontamentoAtrasado !== null &&
        data.diasUteisApontamentoAtrasado !== undefined &&
        data.diasUteisApontamentoAtrasado > 0),
    {
      message: 'Obrigatório (>0) quando permite apontamento atrasado',
      path: ['diasUteisApontamentoAtrasado'],
    },
  );

export type CompanyFormValues = z.infer<typeof companyInputSchema>;
